<template>
    <div class="container">
      <div class="row justify-content-between align-items-center">
          <div class="col-6 text-left">
              <a :href="$t('base.homeLink')" target="_blank"><img alt="Stressless" src="../assets/stressless_logo.svg" width="200" height="100"></a>
          </div>
          <div class="col-6 text-right">
            <a class="home-link" :href="$t('base.homeLink')" target="_blank">{{ $t('base.home') }}</a>
          </div>
      </div>

      <div class="image-header mb-4">
          <div class="hero-image">
              <h1 v-html="$t('base.headline1')"></h1>
          </div>
      </div>

      <p class="mb-4 lead">{{ $t('base.introtext') }}</p>

      <h2 class="my-5">{{ $t('base.headline2') }}</h2>

      <ul class="nav justify-content-center is--navistep mb-3">
        <li v-if="hasMonthEvents(month)" v-for="month in getMonths" class="nav-item">
          <a class="nav-link active" :href="['#' + $t('month.' + month)]">{{ $t('month.' + month) }}</a>
        </li>
      </ul>

      <template v-if="hasMonthEvents(month)" v-for="month in getMonths">
        <div class="is--title months mb-2">
            <a :name="$t('month.' + month)">{{ $t('month.' + month) }}</a>
        </div>

        <div v-if="hasMonthEventsInRegion(month, label)" v-for="(regions, label) in getRegionsByMonth(month)">
          <div class="is--postcode">PLZ: {{ label }}</div>

          <table class="table mb-4">
              <EventCard v-for="event in regions" :key="event.id" :event="event"/>
          </table>
        </div>
      </template>

      <div class="footer">
          <div class="my-3">
              <p><a :href="$t('base.homeLink')">Mehr Details zu Stressless® erhalten</a></p>
          </div>
          <ul class="nav justify-content-center my-3">
              <li class="nav-item">
                  <a class="nav-link active" :href="$t('base.imprintLink')" target="_blank">{{ $t('base.imprint') }}</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" :href="$t('base.dataProtectionLink')" target="_blank">{{ $t('base.dataProtection') }}</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" :href="$t('base.contactLink')" target="_blank">{{ $t('base.contact') }}</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" :href="$t('base.homeLink')" target="_blank">{{ $t('base.home') }}</a>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
  import EventCard from '@/components/EventCard.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      EventCard,
    },

    data() {
      return {}
    },

    computed: {
      ...mapGetters('events', [ 'getEvents', 'getMonths' ]),
    },

    methods: {
      hasMonthEventsInRegion(month, region) {
        return this.$store.getters['events/hasMonthEventsInRegion'](month, region);
      },

      hasMonthEvents(month) {
        return this.$store.getters['events/hasMonthEvents'](month);
      },

      getRegionsByMonth(month) {
        return this.$store.getters['events/getRegionsByMonth'](month);
      },
    },

    beforeCreate() {
      this.$store.dispatch('events/fetchEvents');
    },
  }
</script>

<style lang="scss">
    $orange: #e38633;
    $blue: #1d3661;
    $light-gray: #a1a0aa;

    .lead {
      font-family: 'Lato-Light', Helvetica, Arial, sans-serif;
    }

    .image-header {
        height: 400px;
        position: relative;

        .hero-image {
            background-image: url("../assets/hero.jpg");
            background-size: cover;
            height: 400px;
            width: 100%;
            background-position: left 82%;

            h1{
                color: #ffffff;
                position: absolute;
                top: 40%;
                left: 0;
                right: 0;
                text-shadow: 0 0 10px rgba(0,0,0,.6);

                @media (max-width: 786px) {
                    top: 30%;
                }
            }
        }
    }

    .home-link {
        color: $light-gray;
        font-size: 1.2rem;
    }

    .nav {
        a {
            color: $light-gray;
        }
    }

    .is--navistep {
        li:not(:last-child):after {
            content: '|';
        }

        a {
            display: inline-block;
            color: black;
            font-size: 1.2rem;
        }
    }

    .is--postcode {
        background-color: $orange;
        color: #ffffff;
    }

    .is--title.months {
        font-family: 'Lato-Bold', Helvetica, Arial, sans-serif;
        font-size: 1.8rem;
        color: #ffffff;
        background-color: $blue;
    }

    table {
        text-align: left;
        width: 100%;

        tr {
            border-bottom: 1px solid $orange;
        }

        td {
            border: 0 !important;
        }

        @media (max-width: 786px) {
            tr {
                display: block;
            }

            td {
                display: inline-block;
            }
        }
    }
</style>
